import { render, staticRenderFns } from "./TemplateOverview.vue?vue&type=template&id=053f39c7&scoped=true"
import script from "./TemplateOverview.vue?vue&type=script&lang=js"
export * from "./TemplateOverview.vue?vue&type=script&lang=js"
import style0 from "./TemplateOverview.vue?vue&type=style&index=0&id=053f39c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053f39c7",
  null
  
)

export default component.exports